import { Bet } from 'shared/api';
import { calcDateDay } from './calc-date-day';

export type HistoryBetsByDate = { date: string; rows: Bet[] };

export const groupBetsByDate = (bets: Bet[]) => {
	const groupedBets: HistoryBetsByDate[] = [];

	bets.forEach((bet) => {
		const date = calcDateDay(bet.time);
		const existingGroup = groupedBets.find((group) => group.date === date);

		if (existingGroup) {
			existingGroup.rows.push(bet);
		} else {
			groupedBets.push({
				date,
				rows: [bet],
			});
		}
	});

	return groupedBets;
};
